import { TCrmSettings } from 'types/crm';

import { CRMAPIBase } from '@api/crmApiBase';
import { CRMResp } from '@api/responseModels/crm/crmResponse';
import { RequestResult } from '@api/responseModels/requestResult';

class SettingsGroup extends CRMAPIBase {
    async getCrmSettingsOld(fields: { crm_id: number }): Promise<TCrmSettings> {
        const result = await this.get<CRMResp>(`/crms/${fields.crm_id}`, fields);
        const settings = this.safeExtractData(result, 'data.settings');

        return settings;
    }

    // всегда присылает false
    async getCrmSettings(params: { crm_id: number }): Promise<RequestResult<TCrmSettings>> {
        const result = await this.get<TCrmSettings>(`crm-settings`, params);
        return result;
    }
    async setCrmSettings(fields: {
        crm_id: number;
        name: string;
        value: string;
    }): Promise<RequestResult<CRMResp>> {
        const result = await this.post<null>('crm-settings/change', fields);
        return result;
    }

    async getUserSettings(fields: { crm_id: number }): Promise<TCrmSettings> {
        const result = await this.get<any>(`users/${fields.crm_id}`, fields);
        const settings = this.safeExtractData(result, 'data.settings');

        return settings;
    }

    async setUserSettings(fields: {
        crm_id: number;
        name: string;
        value: string;
    }): Promise<RequestResult<CRMResp>> {
        const result = await this.post<null>('user-settings/change', fields);
        return result;
    }
}
export { SettingsGroup };
